import { AppDateFormats } from 'Core/constants'
import { ConfigItem } from 'Core/interfaces'

export enum TaxCategorySearchFields {
	searchResultByName = 'searchResultByName',
	searchResultByChargeType = 'searchResultByChargeType',
	searchResultByProductCategory = 'searchResultByProductCategory'
}

export enum TaxCategoryFormFields {
	taxCategory = 'taxCategory',
	chargeType = 'chargeType',
	produceCategory = 'produceCategory'
}

export enum TaxRateFields {
	taxRateId = 'taxRateId',
	categoryId = 'categoryId',
	effectiveStartDate = 'effectiveStartDate',
	taxRate = 'taxRate',
	editable = 'editable',
	isVisible = 'isVisible',
	isCollapse = 'isCollapse',
	type = 'type'
}

export enum TaxRateType {
	current = 'current',
	previous = 'previous'
}

export declare namespace TaxCategory {
	interface Basic extends Entity {
		taxCategoryId: number
		chargeType: Entity | null
		productCategory: Entity | null
	}

	interface Detailed extends Basic {}

	namespace Search {
		interface Config {
			[TaxCategorySearchFields.searchResultByName]: ConfigItem<TaxCategorySearchFields>
			[TaxCategorySearchFields.searchResultByChargeType]: ConfigItem<TaxCategorySearchFields>
			[TaxCategorySearchFields.searchResultByProductCategory]: ConfigItem<TaxCategorySearchFields>
		}

		interface Result {
			[TaxCategorySearchFields.searchResultByName]: Entity[] | null
			[TaxCategorySearchFields.searchResultByChargeType]: Entity[] | null
			[TaxCategorySearchFields.searchResultByProductCategory]: Entity[] | null
		}
	}

	interface ProductParams {
		chargeTypeId: number
		productCategoryId: number
	}

	namespace Request {
		interface Create extends ProductParams {
			name: string
		}

		interface Generic extends ProductParams {
			taxCategoryId: number
		}
	}

	namespace Form {
		interface Basic {
			[TaxCategoryFormFields.taxCategory]: BasicString
			[TaxCategoryFormFields.chargeType]: BasicNumber
			[TaxCategoryFormFields.produceCategory]: BasicString
		}

		interface Valid extends Basic {
			[TaxCategoryFormFields.taxCategory]: NonNullable<BasicString>
			[TaxCategoryFormFields.chargeType]: NonNullable<BasicNumber>
			[TaxCategoryFormFields.produceCategory]: NonNullable<BasicString>
		}
	}
}

export declare namespace TaxRate {
	interface Detailed {
		id: number
		taxRate: Key
		effectiveStartDate: string
		category: Entity
		isCollapse?: boolean
	}

	namespace TaxCategory {
		interface Detailed {
			id: number
			effectiveStartDate: BasicString
			taxableFlag: boolean
			category: Entity
		}
	}

	type FieldType = Record<TaxRateFields, Key | moment.Moment | null | boolean>

	interface TableConfig<
		SelectFieldNames extends string,
		InputFieldNames extends string,
		DatepickerFields extends string
	> {
		selects: Record<
			SelectFieldNames,
			{
				options: LabelValue[]
			}
		>
		inputs: Record<InputFieldNames, {}>
		datepicker: Record<DatepickerFields, { getCurrentDateFormat: AppDateFormats }>
	}
	namespace Form {
		interface Generic {
			id?: Key | null
			[TaxRateFields.categoryId]: LabelValue<number> | null
			[TaxRateFields.effectiveStartDate]: moment.Moment | BasicString
			[TaxRateFields.taxRate]: BasicString
			[TaxRateFields.editable]: boolean
			isCollapse?: boolean
			isVisible?: boolean
			type?: TaxRateType
		}
	}
	namespace Request {
		interface Generic {
			id?: Key | null
			[TaxRateFields.categoryId]?: number | null
			[TaxRateFields.effectiveStartDate]: BasicString
			[TaxRateFields.taxRate]: BasicString
		}
	}
}
